import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import general from "./modules/general"
import auth from "./modules/auth"
import user from "./modules/user"
import conference from "./modules/conference"
import contribution from "./modules/paper"
import file from './modules/file/'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    general,
    auth,
    user,
    file,
    conference,
    contribution
  },
})
